<h3 mat-dialog-title>Отмена результата</h3>
<div mat-dialog-content>
  <p>Вы действительно хотите отменить результат?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()">Отмена
  </button>
  <button mat-flat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Отменить результат
  </button>
</div>
